import {
    ComparisonTable,
    MeasurementSystemSizeComparisonTable,
} from "@hermes/api-model-product";
import { CountryCode } from "@hermes/locale";

export function filterTablesToShowOnlySelectedCountry(
    tablesData: MeasurementSystemSizeComparisonTable,
    selectedCountry: string,
    countryList: string[],
): MeasurementSystemSizeComparisonTable {
    const internationalIndexesToRemove = getCountryIndexesToRemove(
        tablesData.international!,
        selectedCountry,
        countryList,
    );
    const imperialIndexesToRemove = getCountryIndexesToRemove(
        tablesData.imperial!,
        selectedCountry,
        countryList,
    );

    return removeIndexesFromTables(
        internationalIndexesToRemove,
        imperialIndexesToRemove,
        tablesData,
    );
}

export function removeIndexesFromTables(
    internationalIndexesToRemove: number[],
    imperialIndexesToRemove: number[],
    sizeComparisonTable: MeasurementSystemSizeComparisonTable,
): MeasurementSystemSizeComparisonTable {
    return {
        international: filterTableData(
            sizeComparisonTable.international!,
            internationalIndexesToRemove,
        ),
        imperial: filterTableData(
            sizeComparisonTable.imperial!,
            imperialIndexesToRemove,
        ),
    };
}

export function filterTableData(
    tableData: ComparisonTable,
    indexes: number[],
): ComparisonTable {
    return {
        headers: filterHeader(tableData?.headers ?? [], indexes),
        lines: filterLines(tableData?.lines ?? [], indexes),
        label: tableData.label,
    };
}

export function filterHeader(
    listOfHeaders: string[],
    indexesToRemove: number[],
): string[] {
    return listOfHeaders.filter((_, index) => !indexesToRemove.includes(index));
}

export function filterLines(
    listOflines: string[][],
    indexesToRemove: number[],
): string[][] {
    return listOflines.map((line) =>
        line.filter((_, index) => !indexesToRemove.includes(index)),
    );
}

export function findDefaultSelectedCountry(
    currentCountry: CountryCode,
    defaultLocation: string,
    countryList: string[],
): string {
    if (countryList.includes(currentCountry.toUpperCase())) {
        return currentCountry.toUpperCase();
    } else if (countryList.includes(defaultLocation)) {
        return defaultLocation;
    }
    return "FR";
}

/**
 * Get all indexes that are not of the selected country
 */
export function getCountryIndexesToRemove(
    table: ComparisonTable,
    selectedCountry: string,
    countryList: string[],
): number[] {
    const indexesToRemove: number[] = [];
    table.headers.forEach((currentHeader, index) => {
        // Filter only when column is a country
        if (
            countryList.includes(currentHeader) &&
            currentHeader !== selectedCountry
        ) {
            indexesToRemove.push(index);
        }
    });
    return indexesToRemove;
}
